import React from 'react';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import proBadgeSrc from 'images/icons/pro-badge-white-bg.svg';
import logoSrc from 'images/icons/cuttlefish/logo.svg';
import * as styles from './styles.module.scss';
import giftCardSvg from './gc-1.svg';

const {
  ALLTRAILS,
  ALLTRAILS_GIFT_SUBSCRIPTION,
  PRO: { ALLTRAILS_PRO }
} = StringConstantsMixin.strings;

function GiftCard1() {
  return (
    <div className={styles.gc}>
      <img alt={ALLTRAILS_GIFT_SUBSCRIPTION} className={styles.img} src={giftCardSvg} />
      <img alt={ALLTRAILS_PRO} className={styles.badge} src={proBadgeSrc} />
      <img alt={ALLTRAILS} className={styles.logo} src={logoSrc} />
    </div>
  );
}

export default GiftCard1;
